<template>
  <div class="tri-state-button" :class="{ 'disabled': disabled }">
    <div class="button-container">
      <button 
        class="tri-button" 
        :class="{ 'active': modelValue === true }"
        @click="updateValue(true)"
        :disabled="disabled"
        type="button"
        aria-label="אישור"
      >
        <span class="icon check_icon"></span>
      </button>

      <button 
        class="tri-button middle-button" 
        :class="{ 'active': modelValue === null }"
        @click="updateValue(null)"
        :disabled="disabled"
        type="button"
        aria-label="ניטרלי"
      >
        <span class="icon minus_icon"></span>
      </button>

      <button 
        class="tri-button" 
        :class="{ 'active': modelValue === false }"
        @click="updateValue(false)"
        :disabled="disabled"
        type="button"
        aria-label="דחייה"
      >
        <span class="icon x_icon"></span>
      </button>
    </div>
    <label class="button-label" v-text="modelValue == true ? 'מאושר' : modelValue == false ? 'לא מאושר' : 'בבדיקה'"></label>
  </div>
</template>

<script>
export default {
  name: 'TriStateButton',
  props: {
    modelValue: {
      type: [Boolean, null],
      default: null
    },
    label: {
      type: String,
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  emits: ['update:modelValue', 'change'],
  methods: {
    updateValue(value) {
      if (this.disabled) return;
      
      // If clicking the same value, toggle to null (except for null which stays null)
      const newValue = this.modelValue === value && value !== null ? null : value;
      
      this.$emit('update:modelValue', newValue);
      this.$emit('change', newValue);
    }
  }
}
</script>

<style lang="scss" scoped>
.tri-state-button { display: flex; align-items: center; border-radius: 50px; background: var(--gray); padding-left: 10px;
  
  &.disabled { opacity: 0.6; cursor: not-allowed; }

  .button-container { padding: 5px 6px; display: flex; gap: var(--gap_small); overflow: hidden;
    
    .tri-button { width: 34px; height: 34px; border-radius: 50%; display: flex; align-items: center; justify-content: center; border: none; background-color: white; cursor: pointer; transition: all 0.2s ease; padding: 0; position: relative;

      &:not(.active) { border: 1px solid #4D7E99; }

      
      &.middle-button {
        // background-color: #F0E172;
        
        &.active { background-color: #F0E172;
          
          .icon { filter: none; }
        }
      }
      
      &:hover:not(.active):not(:disabled) { background-color: #f4f4f5;
        
        &.middle-button { background-color: #f8d44c; }
      }
      
      &:disabled { cursor: not-allowed; }
      
      &.active {
        &:first-child { background-color: #067647; }
        
        &:last-child { background-color: #b42318; }
        
        .icon {
          filter: brightness(0) invert(1);
        }
      }
      
      .icon { width: 16px; height: 16px; display: block; }
      
      .check_icon { background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='%2300466E' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpolyline points='20 6 9 17 4 12'%3E%3C/polyline%3E%3C/svg%3E"); background-size: contain; background-repeat: no-repeat; background-position: center; }
      
      .minus_icon { background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='%2300466E' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3E%3Cline x1='5' y1='12' x2='19' y2='12'%3E%3C/line%3E%3C/svg%3E"); background-size: contain; background-repeat: no-repeat; background-position: center; }
      
      .x_icon { background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='%2300466E' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3E%3Cline x1='18' y1='6' x2='6' y2='18'%3E%3C/line%3E%3Cline x1='6' y1='6' x2='18' y2='18'%3E%3C/line%3E%3C/svg%3E"); background-size: contain; background-repeat: no-repeat; background-position: center; }
    }
  }
  
  .button-label {  text-align: center;  min-width: 80px; font-size: var(--h5, 14px); color: var(--dark_blue); }
}
</style> 